export default "__VITE_ASSET__7445db06__"